'use strict';

var GridToolbarSystemStatusFaresReoptDirective = function GridToolbarSystemStatusFaresReoptDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/grid-toolbar-system-status-fares-reopt.html'),
    controller: 'GridToolbarSystemStatusFaresReoptController',
    link: function link(scope) {
      scope.$on('grid:rowSelectionChanged', function (event, selectedRows) {
        scope.onRowSelection(selectedRows);
      });
    }
  };
};
GridToolbarSystemStatusFaresReoptDirective.$inject = [];
module.exports = GridToolbarSystemStatusFaresReoptDirective;